/**
 * Constantes de tema e dimensões da navegação
 */

export const NAVIGATION_DIMENSIONS = {
  ASIDE_NAV_WIDTH: 220,
  TOP_NAV_HEIGHT: 60,
  BOTTOM_NAV_HEIGHT: 60,
  MOBILE_VISIBLE_ITEMS: 5,
};

export const NAVIGATION_BREAKPOINTS = {
  DESKTOP: 1200,
};

export const NAVIGATION_COLORS = {
  PRIMARY: '#662D91',
  PRIMARY_DARK: '#57277B',
  PRIMARY_HOVER: 'rgba(255, 255, 255, 0.1)',
  TEXT_PRIMARY: '#ffffff',
  TEXT_SECONDARY: '#333333',
  ACCENT: 'rgba(84, 30, 125, 1)',
  BORDER: 'rgba(0, 0, 0, 0.15)',
  DIVIDER: 'rgba(255, 255, 255, 0.3)',
  DRAWER_BG: '#ffffff',
  CLOSE_BUTTON_BG: 'rgba(0, 0, 0, 0.05)',
  CLOSE_BUTTON_HOVER: 'rgba(0, 0, 0, 0.1)',
  CLOSE_BUTTON_TEXT: 'rgba(41, 45, 50, 1)',
};

export const NAVIGATION_SPACING = {
  LOGO_PADDING: '30px 20px',
  LOGO_PADDING_BOTTOM: '30px',
  LIST_ITEM_PADDING: '16px 16px',
  LIST_ITEM_HEIGHT: 60,
  ICON_MARGIN_RIGHT: 12,
  DRAWER_PADDING: '20px',
  MORE_MENU_MARGIN_BOTTOM: 16,
  CARD_PADDING: '20px',
  CARD_MIN_HEIGHT: 100,
};

export const NAVIGATION_BORDER_RADIUS = {
  SMALL: 12,
  LARGE: 20,
};

export const NAVIGATION_ANIMATIONS = {
  TRANSITION_DURATION: '0.3s',
  RIPPLE_DURATION: '2s',
};

export const NAVIGATION_Z_INDEX = {
  BOTTOM_NAV: 100,
};